import React from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { SecureProvider } from './secure-provider';
import Keycloak from 'keycloak-js';
import { CircularProgress } from '@mui/material';
import { KEYCLOAK_CONFIG } from '../config/front-config';
import { GlobalStyles, theme } from '../global/global.styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { setLocale } from 'yup';
import { LocaleFR } from '../locale/validation-locale';
import { BaseAppProviderProps, ProvidersProps } from '@betrue/common-front';
import { QueryParamProvider } from 'use-query-params';
import { ThemeProvider as MUIThemeProvider, createTheme } from '@mui/material/styles';

export interface AppProviderProps extends BaseAppProviderProps {
  loginMode?: string;
}


export function ThemeProviders(props: ProvidersProps) {
  return (
    <>
      <GlobalStyles />
      <MUIThemeProvider theme={props.theme}>
        <StyledThemeProvider theme={props.theme}>{props.children}</StyledThemeProvider>
      </MUIThemeProvider>
    </>
  );
}

setLocale(LocaleFR);

export function AppProvider(props: AppProviderProps) {
  const kc = Keycloak({
    url: KEYCLOAK_CONFIG().authServerUrl,
    realm: KEYCLOAK_CONFIG().realm,
    clientId: KEYCLOAK_CONFIG().clientId,
  });

  return (
    <QueryParamProvider>
      <ThemeProviders theme={theme}>
        <ReactKeycloakProvider
          authClient={kc}
          LoadingComponent={<CircularProgress />}
          initOptions={KEYCLOAK_CONFIG().init}
        >
          <SecureProvider loginMode={props.loginMode}>{props.children}</SecureProvider>
        </ReactKeycloakProvider>
      </ThemeProviders>
    </QueryParamProvider>
  );
}

export default AppProvider;
